import { render, staticRenderFns } from "./ExtLink.vue?vue&type=template&id=2f5a432e&scoped=true"
import script from "./ExtLink.vue?vue&type=script&lang=js"
export * from "./ExtLink.vue?vue&type=script&lang=js"
import style0 from "./ExtLink.vue?vue&type=style&index=0&id=2f5a432e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5a432e",
  null
  
)

export default component.exports